import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0" }),
      createElementVNode("path", { d: "M9.28 8a1.64 1.64 0 0 1 1.13-.46A1.59 1.59 0 0 1 12 9.09v1.41L14.53 8a1.64 1.64 0 0 1 1.13-.46 1.59 1.59 0 0 1 1.59 1.59v5.82a1.59 1.59 0 0 1-1.59 1.59 1.6 1.6 0 0 1-1.13-.54L12 13.5v1.41a1.59 1.59 0 0 1-1.59 1.59 1.6 1.6 0 0 1-1.13-.5L6 12.71a1 1 0 0 1 0-1.42Z" })
    ], -1)
  ]));
}
const entertainmentControlButtonCircleLeftArrowRewind = { render };
export {
  entertainmentControlButtonCircleLeftArrowRewind as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-left-arrow-rewind.svg.js.map
